import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  fullWidth?: boolean;
}
export function Button({
  children,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative overflow-hidden group
        bg-rose-600 hover:bg-rose-700 text-white 
        font-bold text-lg md:text-xl py-4 px-8 rounded-full
        shadow-[0_8px_20px_-6px_rgba(217,108,117,0.6)]
        transition-colors duration-300
        flex items-center justify-center gap-3
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-211">
      <span className="relative z-10 flex flex-col items-center gap-1" data-id="element-212">
        <span className="bg-white/20 text-xs font-bold px-3 py-0.5 rounded-full tracking-wider" data-id="element-213">
          92% OFF
        </span>
        {children}
      </span>
      <ChevronRight className="w-6 h-6 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-214" />

      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0" data-id="element-215" />
    </motion.button>;
}